import {
  Building2,
  CalendarDays,
  ClipboardList,
  FileText,
  Settings2,
  Users,
  type LucideIcon,
} from "lucide-react";

/** メニュー1件分の定義。 */
export interface NavItem {
  /** 表示名。 */
  label: string;
  /** メニューのアイコン。 */
  icon: LucideIcon;
  /** 遷移先のパス。 */
  path: string;
  /** 管理者だけに見せる項目（API 側でも write は ADMIN 限定）。 */
  adminOnly?: boolean;
}

/**
 * アプリのメニュー一覧。**ホームのタイルとドロワーが共有する単一ソース**。
 *
 * 機能を増やすときはここに NavItem を追加すれば両方に反映される
 * （ngtg_msc の kHomeMenuItems と同じ意図）。
 */
export const NAV_ITEMS: NavItem[] = [
  { label: "見積管理", icon: FileText, path: "/quotations" },
  { label: "案件管理", icon: ClipboardList, path: "/projects" },
  { label: "出荷カレンダー", icon: CalendarDays, path: "/shipping-calendar" },
];

/**
 * マスタの一覧（ドロワーの折りたたみの中身）。
 *
 * ホームのタイルには出さないので ``NAV_ITEMS`` とは分けてあるが、アイコンの
 * 単一ソースという役目は同じ（[[screenIcon]]）。
 */
export const MASTER_NAV_ITEMS: NavItem[] = [
  { label: "取引先", icon: Building2, path: "/master/partners" },
  { label: "工程", icon: Settings2, path: "/master/processes" },
  { label: "ユーザー管理", icon: Users, path: "/master/users", adminOnly: true },
];

/**
 * そのパスの画面のアイコンを返す（対応するものが無ければ null）。
 *
 * 一覧も詳細も同じ枠（カード＋テーブル）で、見分けが付くのは左上の文字だけ
 * だった。ドロワーとホームのタイルで使っている絵を見出しにも出して、
 * **どの画面にいるのかを形で分かる**ようにする。絵が画面ごとに違っていないと
 * 意味が無いので、定義はここ 1 箇所に集める。
 *
 * 詳細画面（``/quotations/12``）も一覧と同じ絵にしたいので前方一致で見る。
 * ``/master/partners`` のように深いパスが先に当たるよう、長いものを優先する。
 */
export function screenIcon(pathname: string): LucideIcon | null {
  const hit = [...NAV_ITEMS, ...MASTER_NAV_ITEMS]
    .filter((item) => pathname === item.path || pathname.startsWith(`${item.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return hit?.icon ?? null;
}
